import moment from 'moment';
export default function TagsService(gettextCatalog, appSettings, gettext) {
  'ngInject';

  this.generateTooltip = (tag = {}, dateFormat) => {
    dateFormat = dateFormat || appSettings.GetDateFormat() || 'YYYY/MM/DD';
    const dateTimeFormat = `${dateFormat}  h:mm:ss a`;
    let tip = '';
    switch (tag.dataType) {
      case 'Integer':
        tip = gettextCatalog.getString('Enter an integer ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += gettextCatalog.getString('(minimum {{min}})', {
              min: tag.range.min,
            });
          } else {
            tip += gettextCatalog.getString('from {{min}} to ', {
              min: tag.range.min,
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += gettextCatalog.getString('(maximum {{max}})', {
              max: tag.range.max,
            });
          } else {
            tip += tag.range.max;
          }
        }
        return tip;
      case 'Decimal':
        tip = gettextCatalog.getString('Enter a number ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += gettextCatalog.getString('(minimum {{min}})', {
              min: tag.range.min,
            });
          } else {
            tip += gettextCatalog.getString('from {{min}} to ', {
              min: tag.range.min,
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += gettextCatalog.getString('(maximum {{max}})', {
              max: tag.range.max,
            });
            return tip;
          } else {
            tip += tag.range.max;
          }
        }
        return tip;
      case 'Date':
        tip = gettextCatalog.getString('Select a date ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += gettextCatalog.getString('({{min}} or later)', {
              min: moment(tag.range.min).format(dateFormat),
            });
          } else {
            tip += gettextCatalog.getString('from {{min}} to ', {
              min: moment(tag.range.min).format(dateFormat),
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += gettextCatalog.getString('({{max}} or earlier)', {
              max: moment(tag.range.max).format(dateFormat),
            });
          } else {
            tip += moment(tag.range.max).format(dateFormat);
          }
        }
        return tip;
      case 'Datetime':
        tip = gettextCatalog.getString('Select a date and time ');
        if (tag.range.min) {
          if (!tag.range.max) {
            tip += gettextCatalog.getString('({{min}} or later)', {
              min: moment(tag.range.min).format(dateTimeFormat),
            });
          } else {
            tip += gettextCatalog.getString('from {{min}} to ', {
              min: moment(tag.range.min).format(dateTimeFormat),
            });
          }
        }
        if (tag.range.max) {
          if (!tag.range.min) {
            tip += gettextCatalog.getString('({{max}} or earlier)', {
              max: moment(tag.range.max).format(dateTimeFormat),
            });
          } else {
            tip += moment(tag.range.max).format(dateTimeFormat);
          }
        }
        return tip;
    }
  };

  const attrDataTypesText = {
    text: gettext('Text'),
    integer: gettext('Integer'),
    decimal: gettext('Number'),
    date: gettext('Date'),
    datetime: gettext('Datetime'),
    hyperlink: gettext('Hyperlink'),
  };

  const HasValue = (val) => !!val || val === 0;

  this.getAttrShortHelpText = (attr) => {
    const { dataType, range } = attr || {};
    const { min = undefined, max = undefined } = range || {};

    const type = attrDataTypesText[dataType?.toLowerCase()];
    if (!type) return;

    const typeInfo = gettextCatalog.getString(type);

    if (HasValue(min) && HasValue(max)) {
      return gettextCatalog.getString('{{typeInfo}} between [{{min}} - {{max}}]', {
        typeInfo,
        min,
        max,
      });
    }

    if (HasValue(min)) {
      return gettextCatalog.getString('{{typeInfo}} min {{min}}', { typeInfo, min });
    }

    if (HasValue(max)) {
      return gettextCatalog.getString('{{typeInfo}} max {{max}}', { typeInfo, max });
    }
    return gettextCatalog.getString('{{typeInfo}} value', { typeInfo });
  };
}
